/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type UserFacilityWhereInput = {
    readonly AND?: ReadonlyArray<UserFacilityWhereInput> | null;
    readonly created?: any | null;
    readonly created_btwn?: ReadonlyArray<any> | null;
    readonly created_gt?: any | null;
    readonly created_gte?: any | null;
    readonly created_in?: ReadonlyArray<any> | null;
    readonly created_lt?: any | null;
    readonly created_lte?: any | null;
    readonly created_nbtwn?: ReadonlyArray<any> | null;
    readonly created_nin?: ReadonlyArray<any> | null;
    readonly creator?: string | null;
    readonly creator_btwn?: ReadonlyArray<string> | null;
    readonly creator_gt?: string | null;
    readonly creator_gte?: string | null;
    readonly creator_in?: ReadonlyArray<string> | null;
    readonly creator_lt?: string | null;
    readonly creator_lte?: string | null;
    readonly creator_nbtwn?: ReadonlyArray<string> | null;
    readonly creator_nin?: ReadonlyArray<string> | null;
    readonly facilityUuid?: string | null;
    readonly facilityUuid_btwn?: ReadonlyArray<string> | null;
    readonly facilityUuid_gt?: string | null;
    readonly facilityUuid_gte?: string | null;
    readonly facilityUuid_in?: ReadonlyArray<string> | null;
    readonly facilityUuid_lt?: string | null;
    readonly facilityUuid_lte?: string | null;
    readonly facilityUuid_nbtwn?: ReadonlyArray<string> | null;
    readonly facilityUuid_nin?: ReadonlyArray<string> | null;
    readonly OR?: ReadonlyArray<UserFacilityWhereInput> | null;
    readonly userUuid?: string | null;
    readonly userUuid_btwn?: ReadonlyArray<string> | null;
    readonly userUuid_gt?: string | null;
    readonly userUuid_gte?: string | null;
    readonly userUuid_in?: ReadonlyArray<string> | null;
    readonly userUuid_lt?: string | null;
    readonly userUuid_lte?: string | null;
    readonly userUuid_nbtwn?: ReadonlyArray<string> | null;
    readonly userUuid_nin?: ReadonlyArray<string> | null;
    readonly uuid?: string | null;
    readonly uuid_btwn?: ReadonlyArray<string> | null;
    readonly uuid_gt?: string | null;
    readonly uuid_gte?: string | null;
    readonly uuid_in?: ReadonlyArray<string> | null;
    readonly uuid_lt?: string | null;
    readonly uuid_lte?: string | null;
    readonly uuid_nbtwn?: ReadonlyArray<string> | null;
    readonly uuid_nin?: ReadonlyArray<string> | null;
};
export type FacilityDropdown_QueryVariables = {
    readonly where: UserFacilityWhereInput;
};
export type FacilityDropdown_QueryResponse = {
    readonly userFacilityList: ReadonlyArray<{
        readonly facility: {
            readonly uuid: string;
            readonly name: string;
            readonly logoImageLocation: string | null;
        } | null;
    } | null> | null;
};
export type FacilityDropdown_Query = {
    readonly response: FacilityDropdown_QueryResponse;
    readonly variables: FacilityDropdown_QueryVariables;
};



/*
query FacilityDropdown_Query(
  $where: UserFacilityWhereInput!
) {
  userFacilityList(where: $where) {
    facility {
      uuid
      name
      logoImageLocation
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "UserFacilityWhereInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uuid",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logoImageLocation",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FacilityDropdown_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userFacilityList",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UserFacility",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "facility",
            "storageKey": null,
            "args": null,
            "concreteType": "Facility",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FacilityDropdown_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userFacilityList",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UserFacility",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "facility",
            "storageKey": null,
            "args": null,
            "concreteType": "Facility",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "FacilityDropdown_Query",
    "id": null,
    "text": "query FacilityDropdown_Query(\n  $where: UserFacilityWhereInput!\n) {\n  userFacilityList(where: $where) {\n    facility {\n      uuid\n      name\n      logoImageLocation\n      id\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'e5d6da3156c9d7539941ac7ac4d2d8d5';
export default node;
